<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'FORMS', url: '/admin/forms' },
    { label: 'UPDATE_FORM' }
  ]"
></breadcrumbs>

<page-header title="UPDATE_FORM"></page-header>
<card>
  <form class="form" (submit)="onSubmit($event)">
    <div class="is-flex">
      <div class="field is-narrow mr-4">
        <label class="label">{{ 'NAME' | translate }}</label>
        <div class="control">
          <input
            class="input is-small"
            name="name"
            type="text"
            (input)="handleFieldChange($event)"
            [value]="getField(['name'])"
            [ngClass]="{ 'is-danger': hasError('name') }"
          />
        </div>
        <p class="help is-danger" *ngIf="hasError('name')">
          {{ getError('name') }}
        </p>
      </div>
      <div class="field is-narrow">
        <label class="label" translationEditableDirective="POSTPROCESSOR">{{
          'POSTPROCESSOR' | translate
        }}</label>
        <div class="control">
          <ng-select
            [items]="postprocessors"
            [multiple]="false"
            [closeOnSelect]="true"
            (change)="handleFieldChange($event?.id, 'postprocessorId')"
            [ngClass]="{ 'is-danger': hasError('postprocessorId') }"
            bindLabel="name"
            bindValue="id"
            [ngModelOptions]="{ standalone: true }"
            [ngModel]="getField(['postprocessor', 'id'])"
            class="is-small"
          >
          </ng-select>
        </div>
        <p class="help is-danger" *ngIf="hasError('postprocessorId')">
          {{ getError('postprocessorId') }}
        </p>
      </div>
    </div>

    <app-form-builder
      (onChange)="onFormChange($event)"
      [rows]="getField(['form'])"
    ></app-form-builder>
  </form>
</card>
<div class="field is-grouped px-3 mb-3">
  <div class="control">
    <button
      [disabled]="isLoading"
      type="submit"
      class="button is-success"
      (click)="onSubmit($event)"
      translationEditableDirective="SUBMIT"
    >
      {{ 'SUBMIT' | translate }}
    </button>
  </div>
  <div class="control">
    <button
      [disabled]="isLoading"
      type="submit"
      class="button is-info"
      (click)="onSubmit($event, false)"
      translationEditableDirective="SAVE"
    >
      {{ 'SAVE' | translate }}
    </button>
  </div>
  <div class="control">
    <a
      [routerLink]="['/admin/forms']"
      class="button is-link is-light"
      translationEditableDirective="CANCEL"
    >
      {{ 'CANCEL' | translate }}
    </a>
  </div>
</div>
